import { useFormik } from 'formik'
import { useState } from 'react'

import fetchToCurl from 'fetch-to-curl'
import { useHandleResponseError, useAbortController } from '../../utils'
import useChatHistory from '../../components/History/useChatHistory'
import useScrollToBottom from 'utils/useScrollToBottom'
import { getRequestHeaders } from '../../requestHeder'

export const useBitAgent = () => {
    const { handleResponseError } = useHandleResponseError()
    const { createAbortController, abort } = useAbortController()
    const { scrollRef, scrollToBottom } = useScrollToBottom()

    const [isLoading, setIsLoading] = useState(false)

    const {
        chat,
        chatHistory,
        updateMessagesAndHistory,
        handleStartNewChat,
        setChat,
        handleDeleteHistory,
    } = useChatHistory()

    const initialValues = {
        prompt: '',
        datas: [
            {
                source: 'Wikipedia',
                context: 'Napoleon Bonaparte was exiled to the island of Elba in 1814.',
            },
        ],
    }

    const request_headers = getRequestHeaders()

    const handleSubmit = async (values: any, signal: AbortSignal) => {
        try {
            const { prompt, datas } = values

            updateMessagesAndHistory(prompt, 'You')

            const queryUrl = `${
                import.meta.env.REACT_APP_SUBNET_API
            }/s20_upsilon?synapse_type=QnATask&axon_uid=1`

            const options = {
                method: 'POST',
                headers: request_headers as any,
                body: JSON.stringify({
                    QnATask: {
                        datas: datas,
                        prompt: prompt,
                    },
                    QnAResult: {
                        results: '',
                    },
                    IsAlive: {
                        response: false,
                    },
                }),
                signal,
            }

            const curlString = fetchToCurl(queryUrl, options)?.replace(/\$/g, '\\$')

            const response: any = await fetch(queryUrl, options)

            await handleResponseError(response)

            if (!response.body) return

            //todo steam response
            // handleStreamingResponse(response, (text: string) => {
            //     updateMessagesAndHistory(text, 'Answer', true, curlString)
            // })

            const data = await response.json()

            const text = data?.response?.[0]?.response?.response

            updateMessagesAndHistory(text, 'Answer', true, curlString)
        } catch (e) {
            console.log(e)
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: async (values, formikHelpers) => {
            formikHelpers.setFieldValue('prompt', '') // Reset message to empty string immediately
            setIsLoading(true)
            scrollToBottom()
            const signal = createAbortController()
            await handleSubmit(values, signal)
            setIsLoading(false)
        },
    })

    return {
        responseLoading: isLoading,
        formik,
        setChat,
        handleDeleteHistory,
        chat,
        handleStartNewChat,
        chatHistory,
        scrollRef,
        handleStopRequest: abort,
    }
}
